import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import { backgroundColors, borderColors } from "../utils/common";
Chart.register(...registerables);

interface Props {
  title: string;
  data: any;
  indexAxis?: string | "x";
}

export default function ESBarGraph(props: Props) {
  const { data, title, indexAxis } = props;

  const barChartData = {
    labels: [""],
    datasets: data?.map((item: { Title: any; Count: any }, index: number) => ({
      label: item.Title,
      data: [item.Count],
      backgroundColor: backgroundColors[index % backgroundColors?.length],
      borderColor: borderColors[index % borderColors?.length],
      borderWidth: 1,
      barPercentage: 0.5,
      categoryPercentage: 0.5,
    })),
  };

  const options: any = {
    indexAxis: indexAxis,
    plugins: {
      layout: {
        padding: {
          left: 50,
        },
      },
      legend: {
        display: true,
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 15,
          boxHeight: 10,
          padding: 20,
        },
      },
    },
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
        },
      },
      y: {
        grid: {
          display: true,
        },
        ticks: {
          beginAtZero: true,
        },
      },
    },
  };

  return (
    <>
      <div className=" ">
        <Bar data={barChartData} options={options} />
      </div>
    </>
  );
}
